import { call, put } from 'redux-saga/effects';

import { apiGeneral, notify } from 'services';
import { ICreateRequest } from 'interfaces/create-duck';
import { requestErrorHandler } from 'utils';
import { CreateRtvActions } from 'store/ducks/settings/rtv';

export function* createRtvRequest(action: any) {
  try {
    const { postData, onSuccess } = action as ICreateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.post,
      `/rtv`,
      postData
    );

    const { data } = responseBody;
    yield put(CreateRtvActions.success(data));
    notify('success', 'RTV cadastrado com sucesso');
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify('error', errorMessage);
    yield put(CreateRtvActions.failure(errorMessage));
  }
}
